import {
  AttendanceEmployeeComplianceStatus,
  AttendanceEmployeeSummary
} from 'services/AttendanceTrackingService';

export type AttendanceWorkingHoursTone = 'zero' | 'met' | 'below' | 'very-short';

/** Green ≥ full×days, orange ≥ short×days and < full×days, red < short×days. */
export const getWorkingHoursTone = (
  totalHours: number,
  officeDays: number,
  fullDayHoursThreshold: number,
  shortDayHoursThreshold: number
): AttendanceWorkingHoursTone => {
  if (officeDays <= 0 || totalHours <= 0) return 'zero';

  const fullTarget = officeDays * fullDayHoursThreshold;
  const shortTarget = officeDays * shortDayHoursThreshold;

  if (totalHours >= fullTarget) return 'met';
  if (totalHours >= shortTarget) return 'below';
  return 'very-short';
};

export const formatOfficeDays = (presentDays: number, workingDays: number) =>
  `${presentDays} / ${workingDays}`;

export const formatWorkingHours = (hours: number) => `${hours.toFixed(1)} hrs`;

export const formatLeaveCount = (count: number) => (count > 0 ? String(count) : '—');

export const formatEmployeeSubtitle = (
  summary: AttendanceEmployeeSummary | undefined
) => {
  if (!summary) return 'Loading employee attendance...';
  return `${summary.periodLabel} · ${summary.totalEmployees} employees`;
};

export const formatEmployeeLoadedCount = (
  loadedCount: number,
  totalCount: number
) => {
  if (totalCount === 0) return 'Showing 0 employees';

  return `Showing ${loadedCount} of ${totalCount} employees`;
};

export const formatEmployeePageRange = (
  page: number,
  pageSize: number,
  totalCount: number
) => {
  if (totalCount === 0) return 'Showing 0 employees';

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalCount);
  return `Showing ${start} – ${end} of ${totalCount} employees`;
};

export const getComplianceLabel = (
  status: AttendanceEmployeeComplianceStatus | null,
  isFullCalendarMonth = true
) => {
  if (status === 'Compliant') return 'Compliant';
  if (status === 'BelowThreshold') return 'Below threshold';
  if (!isFullCalendarMonth) return 'Not available for range';
  return 'Not available';
};

export const getComplianceClass = (
  status: AttendanceEmployeeComplianceStatus | null,
  isFullCalendarMonth = true
) => {
  if (status === 'Compliant') return 'compliant';
  if (status === 'BelowThreshold') return 'below';
  if (!isFullCalendarMonth) return 'range';
  return 'na';
};
